const API_URL =
  process.env.REACT_APP_API_URL ||
  (() => {
    const hostname = window?.location?.hostname;

    console.log('[API Config] Determining API URL:', {
      REACT_APP_API_URL: process.env.REACT_APP_API_URL,
      hostname,
      NODE_ENV: process.env.NODE_ENV,
    });

    // Lanternal Production
    if (
      hostname === 'lanternal.harvestgroup.com' ||
      hostname === 'console.harvestgroup.com' ||
      hostname === 'lanternalprodstorage.z13.web.core.windows.net'
    ) {
      console.log('[API Config] Matched Lanternal PROD');
      return 'https://lanternalprod-api.livelybay-ac5e660c.eastus.azurecontainerapps.io';
    }

    // Lanternal Test
    if (
      hostname === 'lanternal-test.harvestgroup.com' ||
      hostname === 'console-test.harvestgroup.com' ||
      hostname === 'console-test-drabd3ayhsgxdtgn.z01.azurefd.net' ||
      hostname === 'lanternaltestsstorage.z13.web.core.windows.net'
    ) {
      console.log('[API Config] Matched Lanternal TEST');
      return 'https://lanternaltests-api.victoriousforest-90d3af1c.eastus.azurecontainerapps.io';
    }

    // Generic Azure Static Web Apps hostnames
    if (hostname && hostname.includes('.z13.web.core.windows.net')) {
      console.log('[API Config] Matched generic z13 hostname, falling back to env or localhost');
      return process.env.REACT_APP_API_URL || 'http://localhost';
    }

    // Default to localhost for development
    console.log('[API Config] No match, defaulting to localhost');
    return 'http://localhost';
  })();

console.log('[API Config] Final API_URL:', API_URL);

const getEnvironment = () => {
  if (!API_URL || API_URL.includes('localhost')) {
    return 'Local';
  } else if (API_URL.includes('lanternaltest-') || API_URL.includes('lanternaltests-api') || API_URL.includes('-tests.')) {
    return 'Test';
  } else if (API_URL.includes('lanternalprod-') || API_URL.includes('lanternalprod-api.harvestgroup.com')) {
    return 'Production';
  } else {
    return 'Production';
  }
};

export const API_ROOT = API_URL;
export const ENVIRONMENT = getEnvironment();

export const getApiEnvironment = () => {
  const env = getEnvironment();
  return env === 'Local' ? 'Local Development' : env;
};

export const isProductionEnvironment = () => ENVIRONMENT === 'Production';
export const isTestEnvironment = () => ENVIRONMENT === 'Test';
export const isLocalEnvironment = () => ENVIRONMENT === 'Local';
